<template>
  <a-icon-sheet-card
    title="Recruiting.Dashboard.NewJobApplicationTitle"
    :count="data.count"
  >
    <div
      v-if="empty"
      v-t="'Recruiting.Dashboard.NewJobApplicationsNoJobApplications'"
      class="p-3"
    />
    <ul v-else class="list-group list-group-flush">
      <li
        v-for="(item, i) in data.jobApplications"
        :key="i"
        class="list-group-item dashboard-dashlet-list-item action-item"
        @click="itemClicked(item)"
      >
        <div class="row">
          <div class="col-auto py-0">
            <img
              :src="getApplicantImage(item)"
              :alt="item.name"
              class="dashboard-dashlet-image-thumbnail"
            />
          </div>
          <div class="col py-0">
            <a-dashlet-list-item-title>
              <span slot="title" v-text="item.name" />
              <span
                slot="addition"
                v-text="$dtFormat(new Date(item.jobApplicationDate))"
              />
            </a-dashlet-list-item-title>
            <div
              v-if="!item.initiativ"
              class="text-muted "
              v-text="item.jobName"
            />
            <div v-else class="row">
              <div class="col py-0 text-muted">
                {{
                  $t(
                    "Recruiting.Dashboard.NewJobApplicationsJobApplicationAs",
                    [item.jobApplicantFor]
                  )
                }}
              </div>
              <span
                v-t="'Recruiting.Dashboard.NewJobApplicationsInitiativ'"
                class="col-auto py-0 text-muted"
              />
            </div>
          </div>
        </div>
      </li>
    </ul>

    <template #actions>
      <a
        v-t="'Recruiting.Dashboard.ShowAll'"
        :disabled="empty"
        :class="{ 'text-muted text-decoration-none': empty }"
        href="javascript:void(0)"
        @click="goToOverview()"
      />
    </template>
  </a-icon-sheet-card>
</template>

<script>
import IconSheetCard from "+/components/card/IconSheetCard";
import utils from "./utils/utils.js";
import DashletListItemTitle from "~/recruiting-system/components/dashboard/DashletListItemTitle";

export default {
  components: {
    "a-icon-sheet-card": IconSheetCard,
    "a-dashlet-list-item-title": DashletListItemTitle
  },
  props: {
    data: { type: Object, default: () => {} }
  },
  computed: {
    empty: function() {
      return this.data.count < 1;
    }
  },
  methods: {
    async goToOverview() {
      if (this.empty) {
        return;
      }
      let lastWeek = new Date();
      lastWeek.setDate(lastWeek.getDate() - 7);

      const lastWeekString = this.$dtFormat(lastWeek);
      await utils.delZSearchSession("iBM_BM");

      const route = {
        path: "/main/bm",
        query: {
          STsearchfield_SB_REFNR: "OWN",
          combovalue_ERL_N: "",
          Bewerbung_vom_VON: lastWeekString,
          sortfield_1: "BWG_VOM",
          z_suche_nach_1: "DESC",
          z_suche_cookie: 1
        }
      };
      this.$router.push(route);
    },
    getApplicantImage(item) {
      return `/persis/main?fn=bm.img&bwg_refnr=${item.jobApplicationId}`;
    },
    itemClicked(item) {
      const route = `/main/bm.akten/persDat?bwr_refnr=${item.jobApplicantId}&bwg_refnr=${item.jobApplicationId}`;
      this.$router.push(route);
    }
  }
};
</script>
